var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import * as moment from 'moment-timezone';
import { HelperService } from "app/lib/helper.service";
import { ModalService } from "app/views/modal/base_modal.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { BillingService2 } from "../billing.service";
var OperationDataComponent = /** @class */ (function (_super) {
    __extends(OperationDataComponent, _super);
    function OperationDataComponent(translate, eventsService, activatedRoute, filter, modalService, helper, router, route, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.translate = translate;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.modalService = modalService;
        _this.helper = helper;
        _this.router = router;
        _this.route = route;
        _this.service2 = service2;
        _this.moment = moment;
        _this.tableLoader = 100;
        _this.years = [];
        _this.months = [];
        _this.columns = [];
        _this.y = [];
        _this.year = (new Date()).getFullYear();
        _this.baseUrl = _this.router.url.split('?')[0];
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
            dateType: 'datePaid'
        };
        _this._isLiveData = 'true';
        _this._isByYears = 'false';
        for (var yyyy = 2017; yyyy <= _this.year; yyyy++) {
            _this.years.unshift(yyyy);
        }
        _this.route.queryParams.subscribe(function (params) {
            _this.year = params.year || moment().year();
            _this._isLiveData = params.isLiveData || 'true';
            _this._isByYears = params.isByYears || 'false';
            _this.eventsService.broadcast('period-change', _this.year);
        });
        return _this;
    }
    Object.defineProperty(OperationDataComponent.prototype, "isLiveData", {
        get: function () {
            return this._isLiveData === 'true';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OperationDataComponent.prototype, "isByYears", {
        get: function () {
            return this._isByYears === 'true';
        },
        enumerable: true,
        configurable: true
    });
    OperationDataComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var y, curYear, prevData, i, arrDates, arrMonths, yyyy, tickDate, partDate, tick, _i, arrDates_1, oneYear, stats, curData, kList, _a, kList_1, k, d, curYear, endDate, tickDate, prevData, i, arrDates, arrMonths, partDate, tick, _b, arrDates_2, oneMonth, stats, curData, kList, _c, kList_2, k, d;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.columns = [];
                        this.months = [];
                        this.tableLoader = 0;
                        return [4 /*yield*/, this.service2.operationData.stats({ headersOnly: true, }).toPromise()];
                    case 1:
                        y = (_d.sent()).y;
                        this.y = y;
                        if (!this.isByYears) return [3 /*break*/, 6];
                        curYear = moment().year();
                        prevData = null;
                        i = 0;
                        arrDates = [];
                        arrMonths = [];
                        for (yyyy = curYear; yyyy >= 2017; yyyy--) {
                            tickDate = moment(yyyy + "-01-01", 'YYYY-MM-DD');
                            arrDates.push(tickDate.format('YYYY-MM-DD 00:00:00'));
                            arrMonths.push(yyyy);
                            if (arrDates.length == 1) {
                                partDate = moment().startOf('day');
                                partDate.add(-1, 'years');
                                arrDates.push(partDate.format('YYYY-MM-DD 00:01:00'));
                                arrMonths.push('-');
                            }
                        }
                        tick = 100 / arrDates.length;
                        _i = 0, arrDates_1 = arrDates;
                        _d.label = 2;
                    case 2:
                        if (!(_i < arrDates_1.length)) return [3 /*break*/, 5];
                        oneYear = arrDates_1[_i];
                        return [4 /*yield*/, this.service2.operationData.stats(this.filter.getCopyFilterParams({
                                oneYear: oneYear.replace(':01:', ':00:'),
                                isNotFullYear: (oneYear.indexOf(':01:') > 0),
                                isLiveData: this.isLiveData,
                            })).toPromise()];
                    case 3:
                        stats = (_d.sent()).stats;
                        curData = stats[0] || {};
                        kList = Object.keys(curData);
                        for (_a = 0, kList_1 = kList; _a < kList_1.length; _a++) {
                            k = kList_1[_a];
                            d = 0;
                            if (i > 0) {
                                d = (prevData[k] / curData[k] - 1) * 100.0;
                            }
                            if (prevData != null) {
                                prevData[k + '_delta'] = d.toFixed(1);
                                if (i == 0) {
                                    curData[k + '_delta'] = d.toFixed(1);
                                }
                            }
                        }
                        prevData = curData;
                        // Когда текущий год, тогда запросов к серверу на одни больше,
                        // потому что для текушего года и последнего месяца нужно сделать два запроса для тренда
                        if (this.year != curYear || i != 1) {
                            this.columns.push(curData);
                            this.months.push(arrMonths[i]);
                        }
                        i++;
                        this.tableLoader = Math.ceil(i * tick);
                        _d.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 10];
                    case 6:
                        curYear = moment().year();
                        endDate = moment(this.year + "-01-01", 'YYYY-MM-DD');
                        tickDate = moment().startOf('month');
                        if (this.year != curYear) {
                            tickDate = moment(this.year + "-12-01", 'YYYY-MM-DD');
                        }
                        prevData = null;
                        i = 0;
                        arrDates = [];
                        arrMonths = [];
                        for (; tickDate >= endDate; tickDate.add(-1, 'months')) {
                            arrDates.push(tickDate.format('YYYY-MM-DD 00:00:00'));
                            arrMonths.push(tickDate.locale('ru').format('MMMM'));
                            if (arrDates.length == 1 && this.year == curYear) {
                                partDate = moment().startOf('day');
                                partDate.add(-1, 'months');
                                arrDates.push(partDate.format('YYYY-MM-DD 00:01:00'));
                                arrMonths.push('-');
                            }
                        }
                        tick = 100 / arrDates.length;
                        _b = 0, arrDates_2 = arrDates;
                        _d.label = 7;
                    case 7:
                        if (!(_b < arrDates_2.length)) return [3 /*break*/, 10];
                        oneMonth = arrDates_2[_b];
                        return [4 /*yield*/, this.service2.operationData.stats(this.filter.getCopyFilterParams({
                                oneMonth: oneMonth.replace(':01:', ':00:'),
                                isNotFullMonth: (oneMonth.indexOf(':01:') > 0),
                                isLiveData: this.isLiveData,
                            })).toPromise()];
                    case 8:
                        stats = (_d.sent()).stats;
                        curData = stats[0] || {};
                        kList = Object.keys(curData);
                        for (_c = 0, kList_2 = kList; _c < kList_2.length; _c++) {
                            k = kList_2[_c];
                            d = 0;
                            if (i > 0) {
                                d = (prevData[k] / curData[k] - 1) * 100.0;
                            }
                            if (prevData != null) {
                                prevData[k + '_delta'] = d.toFixed(1);
                                if (i == 0) {
                                    curData[k + '_delta'] = d.toFixed(1);
                                }
                            }
                        }
                        prevData = curData;
                        // Когда текущий год, тогда запросов к серверу на одни больше,
                        // потому что для текушего года и последнего месяца нужно сделать два запроса для тренда
                        if (this.year != curYear || i != 1) {
                            this.columns.push(curData);
                            this.months.push(arrMonths[i]);
                        }
                        i++;
                        this.tableLoader = Math.ceil(i * tick);
                        _d.label = 9;
                    case 9:
                        _b++;
                        return [3 /*break*/, 7];
                    case 10:
                        this.tableLoader = 100;
                        return [2 /*return*/];
                }
            });
        });
    };
    return OperationDataComponent;
}(BaseComponent));
export { OperationDataComponent };
